export default {
  realms: {
    realmRemoved: 'حوزه حذف شد',
    realmUpdated: 'حوزه به روز رسانی شد',
    realmAdded: 'حوزه افزوده شد',
    realms: 'حوزه ها'
  }
}
